import { IAppItemResponse } from '@interfaces/api';

export enum EShowcaseType {
	APP = 'app',
	BANNER = 'banner',
	PLATFORM = 'platform',
}

// Source:
// none - значение по умолчанию
// new - приложения из блока "новинки"
// rpm - каталожные приложения отсортированные по значению RPM
// saleaction - приложения из блока "скидки и акции"
//
// Type:
// app - показ каталожных приложений
// banner - всевозможные баннеры и промо
// platform - акции платформы

export interface IShowcaseResponse {
	data: IAppItemResponse | IShowcaseResponseBannerData | IShowcaseResponseActionData;
	source: 'none' | 'new' | 'rpm' | 'saleaction';
	type: EShowcaseType;
}

export interface IShowcaseResponseActionData {
	action: string;
	banner?: string;
	pic: string;
	action_info: {
		ActionID: string;
		ActionMinPay: number;
		ActionPayAmount: number;
		ActionPayCount: number;
		ActionPaySum: number;
		ActionPlugin: string;
		ActionStart: number;
		ActionStop: number;
		ActionTriesCount: number;
		BannerThemeID: string;
		BannerThemeOptions_background: string;
		BannerThemeOptions_canvasPicture: string;
		BannerThemeOptions_paymentPicture: string;
		BannerThemeOptions_showcase: {
			button: IShowcaseResponseBannerButton;
			desc: string;
			pic: string;
			title: string;
		};
		text: string;
		type: string;
		url: string;
		desc: string;
		pic: string;
		title: string;
		BannerThemeOptions_theme: number;
		BannerThemeOptions_title: string;
		MoneyBalance: number;
		MoneyBonusEndTime: number;
		MoneyBonusID: number;
		MoneyBonusMinPay: number;
		MoneyBonusTryCnt: number;
	};
}

export interface IShowcaseResponseBannerData {
	banner: string;
	button: IShowcaseResponseBannerButton;
	'date-start'?: string;
	'date-stop'?: string;
	desc: string;
	pic: string;
	title: string;
}

export interface IShowcaseResponseBannerButton {
	text: string;
	type: string;
	url?: string;
}
